<template>
  <div
    v-loading.body="roleLoading"
    element-loading-text="Fetching page..."
    style="width: 100%;"
  >
    <section class="rolelist-header-container">
      <HeaderInfoText :colspan="9" title="ROLES" :meta="metaDetails" />
      <el-pagination
        layout="prev, pager, next, jumper"
        :total="total"
        :page-size="page_size"
        v-model:current-page="page"
        @current-change="loadRoleList"
      />
      <section style="margin-left: auto;">
        <el-button plain @click="toggleFilters">
          {{ showFilters ? 'Hide filters' : 'Show filters' }}
        </el-button>
        <el-button :disabled="!hasCreatePermission" type="primary" icon="plus" @click="createNewModel()" />
      </section>
    </section>
    <section v-if="showFilters" class="rolelist-filter-container">
      <KeywordFilter
        :properties="searchObj"
        style="width: auto;"
      ></KeywordFilter>
    </section>
    <el-table :data="roleList" height="100%" border style="height: 100%;">
      <el-table-column prop="name" label="Code">
        <template v-slot="role">
          <span class="link-mock" @click="createNewModel(role.row)">
            {{ role.row.name }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="description" label="Description" />
      <el-table-column prop="is_active" label="Status">
        <template v-slot="role">
          <el-tag
            :type="role.row.is_active ? 'success' : 'danger'"
            close-transition
          >
            {{ role.row.is_active ? 'Active' : 'Inactive' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <RoleForm
      v-if="canShowForm"
      :roleDetails="currentRole"
      :currentUser="currentUser"
      :hasCreatePermission="hasCreatePermission"
      @onSave="loadRoleList"
      @onDelete="updateRoleList"
      @onClose="canShowForm = false"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import RoleForm from './RoleForm.vue'
import HeaderInfoText from '../../HeaderInfoText.vue'
import KeywordFilter from '../../FilterComponents/KeywordFilter.vue'
import { http } from '@/plugins/http'
import { getHeaders, buildUrlWithQuery } from '@/utils/api'

export default {
  name: 'RoleList',
  components: {
    RoleForm,
    HeaderInfoText,
    KeywordFilter
  },
  data: () => ({
    roleList: [],
    roleLoading: false,
    canShowForm: false,
    currentRole: null,
    page_size: 20,
    perPage: null,
    page: 1,
    total: null,
    showFilters: true,
    searchText: '',
    searchObj: {},
    currentUser: {}
  }),
  created () {
    this.searchObj = {
      sync: value => {
        this.searchText = value
      },
      clear: () => {
        this.searchText = ''
      },
      apply: this.loadRoleList
    }
    this.loadRoleList()
    this.getCurrentUser()
  },
  computed: {
    ...mapGetters({
      checkIfUserHasRequiredPermissions: 'checkIfUserHasRequiredPermissions',
      user: 'getUser'
    }),
    metaDetails () {
      return { count: this.total, shown: this.perPage }
    },
    hasCreatePermission () {
      return this.checkIfUserHasRequiredPermissions(['system.view_roles', 'system.add_roles'])
    }
  },
  methods: {
    // Get current user details for filtering internal roles
    async getCurrentUser () {
      try {
        const instanceUrl = this.$store.getters.getActiveInstance.url
        const headers = getHeaders(this.$store.getters.getToken)
        let { data } = await http.get(`${instanceUrl}users/${this.user.userId}`, { headers })
        this.currentUser = data
        return data
      } catch (e) {
        return null
      }
    },
    async loadRoleList () {
      try {
        this.roleLoading = true
        const instanceUrl = this.$store.getters.getActiveInstance.url
        const headers = getHeaders(this.$store.getters.getToken)
        let { page, searchText } = this
        let payload = { page, search: searchText }
        let { data } = await http.get(buildUrlWithQuery('roles', payload, instanceUrl), { headers })
        this.roleList = (data.results || []).slice().sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: 'base' }))
        this.total = data.count || null
        this.perPage = data.results.length
      } catch (e) {
      }
      this.roleLoading = false
    },
    toggleFilters () {
      this.showFilters = !this.showFilters
    },
    createNewModel (roleObj = null) {
      this.currentRole = roleObj
      this.canShowForm = true
    },
    updateRoleList () {
      this.page = 1
      this.loadRoleList()
    }
  }
}
</script>
<style scoped>
.rolelist-header-container {
  display: flex;
  align-items: center;
  padding-right: 12px;
  border-bottom: 1px solid lightgray;
}
.rolelist-filter-container {
  padding: 12px 4px;
}
</style>
